module.exports = __webpack_public_path__ + "static/media/all_green_waves_transparent.450a50d4.png";